@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-100 w-575">
        <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ 'i18n_af_dialogExecutionConfirmationDialogTitle' | translate  }}</div>
        <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
            {{ 'i18n_af_dialogExecutionConfirmationDialogSubtitle' | translate }}
        </div>
        <af-drop-zone formControlName="files"
                      class="w-100"
                      label="i18n_af_attachFileTitle"
                      hint="i18n_af_attachPaymentOrderHint"
                      [hasGridUploadedDocContainer]="false"
                      [bucket]="BucketName.REFUND_FILES"
                      [multiple]="false"/>
        <ui-kit-button
            class="mt-32"
            [disabled]="form.invalid"
            (clickListener)="dialogRef.close(form)"
            [label]="'i18n_af_buttonExecuteRefund' | translate"/>
        <ui-kit-button
            class="mt-16"
            type="text"
            (clickListener)="dialogRef.close()"
            [label]="'i18n_af_buttonCancel' | translate"/>
    </form>
}
